import axios from "axios";
import env from "../variables/EndpointEnvironment";

const SettingsAPI = (props) => {
  return axios.post(`${env.HOST}/settings`, null, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default SettingsAPI;
